module.exports = __webpack_public_path__ + "img/stock2.292f3f7e.png";